export const claimTypeOptions = [
  { label: 'Investigation', value: 'investigation' },
  { label: 'Partial damage', value: 'partial_damage' },
  { label: 'Whole damage', value: 'whole_damage' },
  { label: 'Missing item', value: 'missing_item' },
];

export const claimStatusOptions = [
  { label: 'Draft ({{count}})', buttonLabel: 'Draft', value: 'draft' },
  { label: 'Submitted ({{count}})', buttonLabel: 'Submitted', value: 'submitted' },
  { label: 'Resubmitted ({{count}})', buttonLabel: 'Resubmitted', value: 'resubmitted' },
  { label: 'Action required ({{count}})', buttonLabel: 'Action required', value: 'action_required' },
  { label: 'In progress ({{count}})', buttonLabel: 'In progress', value: 'in_progress' },
  { label: 'Accepted ({{count}})', buttonLabel: 'Accepted', value: 'accepted' },
  { label: 'Credit note pending ({{count}})', buttonLabel: 'Credit note pending', value: 'credit_note_pending' },
  { label: 'Successful ({{count}})', buttonLabel: 'Successful', value: 'successful' },
  { label: 'Declined ({{count}})', buttonLabel: 'Declined', value: 'declined' },
  { label: 'Escalating ({{count}})', buttonLabel: 'Escalating', value: 'escalating' },
  { label: 'Payment overdue ({{count}})', buttonLabel: 'Payment overdue', value: 'payment_overdue' },
  { label: 'Incorrect payment ({{count}})', buttonLabel: 'Incorrect payment', value: 'incorrect_payment' },
  { label: 'Paid ({{count}})', buttonLabel: 'Paid', value: 'paid' },
];

export const claimShipmentTypesOptions = [
  { label: 'Seven Senders', value: '7s' },
  { label: 'Non Seven Senders', value: 'non-7s' },
];

/* eslint-disable camelcase */
export const claimStatusCountMap = {
  accepted: 'acceptedCount',
  action_required: 'actionRequiredCount',
  credit_note_pending: 'creditNotePendingCount',
  declined: 'declinedCount',
  in_progress: 'inProgressCount',
  resubmitted: 'resubmittedCount',
  submitted: 'submittedCount',
  successful: 'successfulCount',
  escalating: 'escalatingCount',
  payment_overdue: 'paymentOverdueCount',
  incorrect_payment: 'incorrectPaymentCount',
  paid: 'paidCount',
  draft: 'draftCount',
};

export const claimDorStatusOptions = [
  { label: 'Completed', value: 'completed' },
  { label: 'Pending', value: 'pending' },
  { label: 'Rejected', value: 'rejected' },
  { label: 'Expired', value: 'expired' },
];
/* eslint-enable camelcase */
